import React, { useRef } from "react"
import { documentToReactComponents } from "@contentful/rich-text-react-renderer"
import { Link, graphql, useStaticQuery } from "gatsby"
import { GatsbyImage, getImage } from "gatsby-plugin-image"

import ContentfulLongText from "../ContentfulLongText"
import SlickSlider from "../SlickSlider/slickslider"
import { ArrowLeft, ArrowRight } from "../Arrow"

import "./blogListSlider.css"

export const BlogListSlider = ({ className = "", content, currentPostId, hasDate=true, showLast=0, colorValue }) => {
  const data = useStaticQuery(
    graphql`
      query {
        allContentfulBlogPosts(
          sort: { fields: createdAt, order: DESC }
          filter: { isDraft: { ne: true } }
        ) {
          nodes {
            createdAt
            isDraft
            parentCategory{
              categoryName
              slugId
            }
            publishDate
            title
            excerptContentOptions
            excerpt {
              raw
            }
            introTextStyling {
              fontSize
              lineHeight
              content {
                content
              }
            }
            outroTextStyling {
              fontSize
              lineHeight
              content {
                content
              }
            }
            intro{
              intro
            }
            blogBodyContent {
              textContent {
                textContent
              }
              packagingView360 {
                mediaSliderName
                titleVisibility
                colorPicker
                images { gatsbyImageData(width: 2400, quality: 100) }
              }
            }
            thumbnailImage {
              gatsbyImageData(width: 2400, quality: 100)
            }
            thumbnailPosition
            thumbnailMedia {
              title
              altTag
              image { gatsbyImageData(width: 2400, quality: 100) }
            }
            blogPostUrlSlug
            categories {
              title
            }
            thumbnailPosition
            languagePreference
          }
        }
      }
    `
  )  

  const sliderRef = useRef(null)

  const blogPosts = data.allContentfulBlogPosts.nodes
  let filteredPosts = [];
  if (content && content.length > 0) {
    const order = content.map(item => item.blogPostUrlSlug);
    filteredPosts = order.map(slug =>
      blogPosts.find(post => post.blogPostUrlSlug === slug)
    );
  } else if(currentPostId !== undefined) {
    filteredPosts = blogPosts.filter(post => post.blogPostUrlSlug !== currentPostId)
  }else {
    filteredPosts = blogPosts;
  }

  filteredPosts = filteredPosts;
  if (showLast > 0) {
    filteredPosts = filteredPosts.slice(0, showLast);
  }
  if (filteredPosts.length === 0) {
    return <div className="no-posts">No Posts Available</div>
  }

  const isWhite = colorValue === 'rgb(229, 62, 62)' ? 'text-white': 'text--dark'
  console.log(blogPosts)
  return (
    <div className={`relative blog-list-slider ${className}`}>
      <div className="w-full blog-arrows" style={{ display: 'flex', alignItems: 'center' }}>
          <button className="btn--plain btn--left" onClick={() => sliderRef.current.slickPrev()}><ArrowLeft/></button>
          <button className="btn--plain btn--right" onClick={() => sliderRef.current.slickNext()}><ArrowRight /></button>
      </div>
      <div className="mb-24" style={{ width: 'auto' }}>
        <Link to="/blog/" className={isWhite} style={{ fontWeight: '600', textDecoration: 'underline' }}>View All Savor Stories</Link>
      </div>
      <SlickSlider refVal={sliderRef} classNameVal={filteredPosts.length < 4 && 'pos-left--zero'} >
        {filteredPosts.map((post, index) => {
          if(post !== undefined) {
            const blogContentHasData = post.blogBodyContent?.[0]?.textContent?.textContent || post.excerpt.raw;

            let excerptContent = 
              post.blogBodyContent === null 
                ? post.excerpt.raw 
                : (post.excerptContentOptions === null || post.excerptContentOptions === 'Default: Body Content') 
                  ? blogContentHasData 
                  : (post.excerptContentOptions === 'Intro Content' && post.introTextStyling !== null) 
                    ? post.introTextStyling.content.content 
                    : blogContentHasData;
            return (
              <div key={index} className='carousel-slide'>
                <div className="blog-tile">
                  <div className={`blog-tile-thumb ${post.thumbnailPosition !== null ? post.thumbnailPosition : 'center'}`}>
                    {post.thumbnailMedia ? (
                      <a href={`/${post.parentCategory.slugId}/${encodeURIComponent(post.blogPostUrlSlug)}/`}>
                        <GatsbyImage
                          image={getImage(post.thumbnailMedia.image)}
                          alt={post.thumbnailMedia.altTag}
                        />
                        {/* <img src={post.thumbnailMedia.image.gatsbyImageData.images.fallback.src} alt={post.thumbnailMedia.altTag} /> */}
                      </a>
                    ):post.thumbnailImage && (
                      <a href={`/${post.parentCategory.slugId}/${encodeURIComponent(post.blogPostUrlSlug)}/`}>
                        <GatsbyImage
                          image={getImage(post.thumbnailImage)}
                          alt={`${post.title} thumbnail`}
                        />
                      </a> 
                    )}
                  </div>
                  <div className="blog-meta">
                    <span className={`blog-meta-left ${isWhite}`}>
                      {post.categories !== null ? (
                        <>{post.categories.map((item, index) => (
                          <React.Fragment key={index}>
                            {item.title}
                            {index < post.categories.length - 1 && ', '}
                          </React.Fragment>
                        ))}</>
                      ) : null}
                    </span>
                    {hasDate && <span className="blog-meta-right">{post.publishDate.split("T")[0]}</span>}
                  </div>
                  <a href={`/${post.parentCategory.slugId}/${encodeURIComponent(post.blogPostUrlSlug)}/`} className="decoration-none">
                    <h3 className={`bold text-secondary font-secondary my-10 ${isWhite}`}>
                      {post.title}
                    </h3>
                  </a>
                  {post.blogBodyContent !== null ? <ContentfulLongText longTextContent={excerptContent} hasLimitChar={true} isThumbnail={true} classNameProp={`blog-thumbnail ${isWhite}`} />:documentToReactComponents(JSON.parse(excerptContent))}
                </div>
              </div>
            )
          } else {
            return false;
          }
        })}
      </SlickSlider>
    </div>
  )  
}